/*
 * @Description:
 * @Author: shenkaiyao
 * @Date: 2020-12-16 11:25:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-16 11:26:31
 */
import LocationTracking from './locationTracking';

export default LocationTracking